<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>View Menu Detail</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
                <v-btn color="grey" dark class="mb-2 mr-2" @click="$router.go(-1)" small>
                    <v-icon small>mdi-arrow-left</v-icon>
                    Back
                </v-btn>
            </v-toolbar>
            <div class="mt-3">
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Menu Name</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-text-field v-model="menu_name" filled rounded dense hide-details="auto"
                            readonly></v-text-field>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="bottles" item-value="code"
                            item-text="description" v-model="selectedBottle" />
                    </v-col>
                </v-row>
                <v-row class="compact-form my-2 mx-1">
                    <v-col>
                        <v-card outlined>
                            <v-skeleton-loader v-if="isLoading" v-bind="attrs"
                                type="table-heading, list-item-two-line, table-tfoot"></v-skeleton-loader>
                            <v-simple-table v-else class="spreadsheet-table flex-table" fixed-header height="400">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="header-cell text-center" width="10">No</th>
                                            <th class="header-cell text-center">Product</th>
                                            <th class="header-cell text-center">Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(product, idp) in filteredItems" :key="product.product_code">
                                            <td class="header-cell text-center">{{ idp + 1 }}</td>
                                            <td class="header-cell text-no-wrap">
                                                {{ product.product_code }}
                                                {{ product.product_name }} ({{ product.product_size }}
                                                ML)
                                            </td>
                                            <td class="header-cell text-center">
                                                {{ product.quantity }}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="2" class="text-right">Total Quantity</th>
                                            <th class="text-center">{{ sumQty || "0" }}</th>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </v-card>
                        <v-simple-table class="mt-3">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="header-cell"></th>
                                        <th class="header-cell text-center">
                                            <span>
                                                Total
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(category, i) in productCategories" :key="i">
                                        <td class="header-cell">{{ category.name }}</td>
                                        <td class="header-cell text-center">
                                            {{ calculateCategorySummary(category) }} %
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th class="header-cell"></th>
                                        <td class="header-cell text-center font-weight-bold	">
                                            {{ calculateTotalCategorySummary() }} %
                                        </td>
                                    </tr>
                                </tfoot>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            details: [],
            products: [],
            bottles: [],
            selectedBottle: "250",
            menu_name: "",
            volume_desc: "",
            items: [],
            attrs: {
                class: "mb-6",
                boilerplate: true,
                elevation: 2,
            },
            productCategories: [],
        };
    },

    computed: {
        filteredItems() {
            return this.items.filter(
                (item) => item.product_size === this.selectedBottle
            );
        },
        sumQty() {
            if (!this.filteredItems || this.filteredItems.length === 0) return 0;

            return this.filteredItems.reduce((total, product) => {
                const qty = Number(product.quantity);
                return total + (isNaN(qty) ? 0 : qty);
            }, 0);
        },
    },

    async created() {
        this.isLoading = true;

        await this.getDataProducts();

        await this.getBottles();

        await this.fetchDetails();

        await this.getProductCategories();

        this.isLoading = false;
    },

    methods: {
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes
                .filter((i) => i.type.includes("Botol"))
                .sort((a, b) => {
                    return parseInt(a.code) - parseInt(b.code);
                });
        },
        async getDataProducts() {
            let response = await this.$store.dispatch("variant/getObjs");
            if (response.data.status == "success") {
                this.products = response.data.data;
                this.products = this.products
                    .filter((p) => p.is_active == 1)
                    .sort((a, b) => a.sort_no - b.sort_no);
            }
        },
        async fetchDetails() {
            if (this.$route.params.code == "new") {
                return;
            }

            this.isLoading = true;

            try {
                const paramId = this.$route.params.code;
                const response = await this.$store.dispatch(
                    "masterdatamenu/getObj",
                    paramId
                );
                this.menu_name = response.menu_name;
                this.details = response.details;
                this.selectedBottle = response.volume_code;
                this.volume_desc = response.volume_desc;

                this.items = this.products.map((product) => ({
                    product_code: product.code,
                    product_name: product.name,
                    product_size: product.size,
                    product_category_code: product.product_category_code,
                    quantity: this.qtyFromDetail(product.code),
                }));
            } catch (error) {
                console.log("Error fetching master menu detail:", error);
            } finally {
                this.isLoading = false;
            }
        },
        qtyFromDetail(productCode) {
            let result = 0;
            const detailSelected = this.details.find(
                (product) => product.variant_code == productCode
            );
            if (detailSelected) {
                result = detailSelected.quantity;
            }

            return result;
        },
        async getProductCategories() {
            let response = await this.$store.dispatch("productcategory/getObjs");
            if (response.data.status == "success") {
                this.productCategories = response.data.data;
            }
        },
        calculateCategorySummary(category) {
            const totalPerCategory = this.filteredItems
                .filter((item) => item.product_category_code === category.code)
                .reduce((total, item) => total + Number(item.quantity || 0), 0);

            const totalProduct = this.filteredItems.reduce(
                (total, item) => total + Number(item.quantity || 0),
                0
            );

            if (!totalProduct) return 0;

            const percent = (totalPerCategory / totalProduct) * 100;

            return Math.ceil(percent);
        },
        calculateTotalCategorySummary() {
            const total = this.productCategories.reduce(
                (total, item) => total + Number(this.calculateCategorySummary(item)),
                0
            );

            return Math.ceil(total);
        },
    },
};
</script>

<style scoped>
.v-text-field fieldset,
.v-text-field .v-input__control,
.v-text-field .v-input__slot {
    border-radius: 7px !important;
}

.spreadsheet-table {
    border-collapse: collapse;
    width: 100%;
}

.header-cell {
    border: 1px solid #ddd;
    padding: 8px !important;
    text-align: left;
    min-width: 100px;
}

.flex-table {
    display: flex;
    flex-grow: 1;
    width: 100%;
}

.flex-table>div {
    width: 100%;
}

.v-data-table table tfoot th {
    position: sticky;
    bottom: 0;
    background: #fff;
}
</style>
